import * as React from "react"
import { CrossSellCarousel } from "../../../../components/crossSellCarousel";
import { useRecentlyViewedProductsCarousel } from "../../../../hooks/useRecentlyViewedProductsCarousel";
import { CrossSell } from "../../../../components/crossSell";
import { useRecentlyViewedProductQuery } from "../../../../hooks/useRecentlyViewedProductQuery";
import { CrossSellCarouselModel } from "../../../../models/view/crossSellCarouselModel";
import { CrossSellListType } from "../../../../definitions/enums";
import { pushToDataLayer } from "../../../../hooks/useCrossSellDataLayerPush";

export const RecentlyViewed = () => {
    const { productIds } = useRecentlyViewedProductsCarousel();

    if (productIds.length > 0) {

        const products: Array<{
            title: string;
            sku: string;
            price: number;
            listType: string;
        }> = [];

        // Populate the products array
        productIds.forEach((productId) => {

            const model = useRecentlyViewedProductQuery(productId);

            if (model) {
                products.push({
                    title: model.product.title,
                    sku: model.product.sku,
                    price: model.price.unitPrice,
                    listType: 'ProductNew | Recently Viewed',
                });
            }
        });

        // Push the data to the data layer
        pushToDataLayer(products);

    }


    // If there are no recently viewed products, don't render anything
    if (productIds.length === 0) return <></>;


    return (
        <CrossSellCarousel model={new CrossSellCarouselModel(<div className="fs-3 ms-2 p-3">Recently viewed</div>)}>
            {productIds.map((productId, index) => <Item key={productId} productId={productId} index={index} />)}
        </CrossSellCarousel>
    )
}

const Item = ({ productId, index }: { productId: number, index: number }) => {
    const model = useRecentlyViewedProductQuery(productId);
 
    // If the model is null, don't render anything
    if (!model) return <></>;

    return <CrossSell listType={CrossSellListType.RecentlyViewed} model={model} index={index} />;
}